module.exports = __webpack_public_path__ + "img/mes.dd995b18.png";